var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-no-data-text"},[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.pgettext('dashboards', 'No data available for current period'))+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }